<script setup lang="ts">
interface Props {
  text: string
  location?: 'top' | 'bottom' | 'start' | 'end'
}

withDefaults(defineProps<Props>(), {
  location: 'top',
})
</script>

<template>
  <v-tooltip :location="location">
    <template #activator="{ props: activatorProps }">
      <span v-bind="activatorProps">
        <slot />
      </span>
    </template>
    {{ text }}
  </v-tooltip>
</template>

<style scoped lang="scss">
</style>
